import { ReactRenderer } from "@tiptap/react";
import TiptapSuggestion from "@tiptap/suggestion";
import { PluginKey } from "prosemirror-state";
import tippy from "tippy.js";
import MentionList from "./MentionList";
const Suggestion = (editor, {
  mentionTrigger,
  getMentions,
  visibleItemsBeforeOverflow,
  handleDropdownOpen,
  handleDropdownClose,
  supportWhitespace = true,
  zIndex
}) => {
  const shouldEndMentioningProcess = (query, items) => {
    const names = items.map((item) => item.name.toLowerCase());
    return !names.some((name) => name.includes(query.toLowerCase()));
  };
  return TiptapSuggestion({
    editor,
    char: mentionTrigger,
    allowSpaces: supportWhitespace,
    pluginKey: new PluginKey("mention"),
    command: ({
      editor: editor2,
      range,
      props
    }) => {
      const { name, slug, id } = props;
      editor2.chain().focus().insertMention({ name, slug, id }, range).run;
    },
    items: async ({ query }) => {
      const mentions = await getMentions(query);
      return mentions.map((mention) => ({
        name: mention.name,
        slug: mention.slug,
        avatar: mention.avatar,
        id: mention.id
      })).slice(0, visibleItemsBeforeOverflow);
    },
    render: () => {
      let component;
      let popup;
      return {
        onStart: (props) => {
          component = new ReactRenderer(MentionList, {
            editor,
            props
          });
          component.element.setAttribute("dir", "");
          if (handleDropdownOpen) {
            handleDropdownOpen();
          } else {
            const portal = document.querySelector("[data-hook=ricos-portal]") ?? document.body;
            popup = tippy("body", {
              getReferenceClientRect: () => props.clientRect?.() ?? new DOMRect(),
              appendTo: () => portal,
              content: component.element,
              showOnCreate: true,
              interactive: true,
              trigger: "manual",
              placement: "bottom-start",
              zIndex
            });
          }
        },
        onUpdate(props) {
          component.updateProps(props);
          if (!handleDropdownOpen) {
            popup[0].setProps({
              getReferenceClientRect: () => props.clientRect?.() ?? new DOMRect()
            });
          }
        },
        onKeyDown(props) {
          if (props.event.key === "Escape") {
            this.onExit?.();
            return true;
          }
          const { items, query } = component.props;
          if (props.event.key === "Enter" && shouldEndMentioningProcess(query, items)) {
            this.onExit?.();
            return false;
          }
          if (!handleDropdownClose) {
            return component.ref?.onKeyDown?.(props) ?? false;
          }
          return false;
        },
        onExit() {
          component?.destroy?.();
          if (handleDropdownClose) {
            handleDropdownClose();
          } else {
            popup[0].destroy();
          }
        }
      };
    }
  });
};
export {
  Suggestion
};
//# sourceMappingURL=suggestion.js.map
